import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { myEpikBaseURL, unifiedBaseURL } from '../lib/api/api';

/**
 * Custom React hook for fetching data from a specified API endpoint using Axios.
 *
 * @param {string} endpoint - The API endpoint to be called.
 * @param {boolean} enabled - A flag to determine if data fetching is enabled on component render (default is true).
 * @returns {object} - An object containing loading state, fetched data, and a fetchData function.
 */

export function useUnifiedFetch(endpoint, enabled = true, isMyEpik) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [data, setData] = React.useState();

  const fetchData = React.useCallback(async () => {
    if (!endpoint) {
      return;
    }

    try {
      setIsLoading(true);

      const url = `${isMyEpik ? myEpikBaseURL : unifiedBaseURL()}${
        process.env.REACT_APP_UNIFIED_API_VERSION
      }/${endpoint}`;
      const token = localStorage.getItem('jwtToken') || null;
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const { data } = await axios.get(url, {
        headers,
      });

      setData(data);

      return data;
    } catch (err) {
      toast.error(JSON.stringify(err.response.data));
    } finally {
      setIsLoading(false);
    }
  }, [endpoint]);

  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    fetchData();
  }, [endpoint, enabled, fetchData]);

  return { isLoading, data, fetchData };
}
